
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"y":"7","width":"16","height":"2","rx":"1","fill":"#072521"}}),_c('rect',{attrs:{"y":"2","width":"16","height":"2","rx":"1","fill":"#072521"}}),_c('rect',{attrs:{"x":"6","y":"12","width":"10","height":"2","rx":"1","fill":"#072521"}})])
      }
    
      }
    